export const setCampaign = ( year ) => {

    return {
      type: 'SET_CAMPAIGN',
      payload: year
    }
  
}